import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRAILER = {
  nickname: 'PRODUCTS.TRAILER.shortname',
  properties: [
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'BRANN_TYVERI' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN', value: 'BRANN' },
        ]
      }
    },
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      TRAILER: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/[a-zA-Z]{2}\d{4}/)
      ]]
    },
    { name: 'tffVehicleBrand', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO' },
    { name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR', group: 'OBJECT_INFO'},
    { name: 'tffRegisteredOnOwnerFirstTime', key: 'TFF_REGISTERED_ON_OWNER_FIRST_TIME', group: 'INSURANCE_INFO' },
    { name: 'trailerType', key: 'TRAILER_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.CAMPING_TRAILER', value: 'CAMPING_TRAILER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.CAMPING_TRAILER_STATIONARY', value: 'CAMPING_TRAILER_STATIONARY' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.TENT_PLATFORM', value: 'TENT_PLATFORM' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.PASSENGER_CAR_TRAILER', value: 'PASSENGER_CAR_TRAILER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.TRACTOR_TRAILER', value: 'TRACTOR_TRAILER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAILER_TYPE.MOTORCYCLE_TRAILER', value: 'MOTORCYCLE_TRAILER' },
        ]
      }
    },
    { name: 'trailerMarketValue', key: 'MARKET_VALUE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.4', value: '4000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.6', value: '6000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.12', value: '12000' }
        ]
      },
    },
    { name: 'vehicleMortage', key: 'VEHICLE_MORTAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'includeExtendedSumFixedEquipment', key: 'INCLUDE_EXTENDED_SUM_FIXED_EQUIPMENT', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isIncludeExtendedSumFixedEquipmentCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'contentsSumInsured', key: 'EXTENDED_SUM_AMOUNT', group: 'INSURANCE_INFO',
    },
    {
      name: 'includeExtendedSumMovables', key: 'INCLUDE_EXTENDED_SUM_MOVABLES', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isIncludeExtendedSumMovablesCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'productSumInsured', key: 'EXTENDED_SUM_AMOUNT', group: 'INSURANCE_INFO',
    },
  ],
  icon: 'trailer'
};
